import cssVariables from 'src/styles/cssVariables'
import { createGlobalStyle } from 'styled-components'
import 'react-loading-skeleton/dist/skeleton.css'

import { TYPOGRAPHY_COLOR } from './variables'

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Roboto', sans-serif;
    color: ${TYPOGRAPHY_COLOR};
  }

  p {
    font-size: 22px;
  }

  a:hover {
    color: var(--linkColor);
  }

  label {
    margin-bottom: 0;
  }

  div[class*="rTapNumber"]:empty {
    display: none;
  }

// Gnatta Styles

.gnatta-inline-webchat-host-fullscreen {
    overflow-y: hidden;
    position: fixed;
}

.gnatta-webchat-hidden {
    display: none;
}

.gnatta-inline-webchat {
    max-width: 400px;
    max-height: 600px;
    width: 100%;
    height: 100%;
    position: fixed;
		bottom: 15px;
		right: 45px;
    overflow: hidden;
    visibility: visible;
    z-index: 99999;
    border: 0;
}

/* gnatta global styles */

.gnatta-inline-webchat iframe {
    width: 100%;
    height: 100%;
	border: 1px solid #e1e1e1;
    box-shadow: 0 24px 0;
}

.gnatta-inline-webchat-collapse {
    max-width: 400px;
	max-height: 46px;
    position: fixed;
	bottom: 0px;
	right: 0px;
	z-index: 9999;
  display: none;
}

@media screen and (max-width: 430px) {
    .gnatta-inline-webchat-collapse {
        width:100%;
        max-width: 100%;
        max-height: 46px;
        position: fixed;
        bottom: 0px;
        right: 0px;
        z-index: 9999;
    }
}

.gnatta-inline-webchat.fullscreen {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    border: 0;
    padding: 0;
    margin: 0;
    float: none;
	z-index: 9999;
	border: none;
}

#gwc-chatAvailable {
  background-color: rgb(255, 195, 0);
}

#gwc-chatAvailable:after {
  position:absolute;
  bottom:0;
  right:0;
  content: '';
  width:15px;
  height:15px;
  background: green;
  border-radius:20px;
  border: 1px solid white;
}

#gwc-chatBusy {
  background-color: rgb(255, 195, 0);
  color: white
}

#gwc-chatBusy:after {
  position:absolute;
  bottom:0;
  right:0;
  content: '';
  width:15px;
  height:15px;
  background: orange;
  border-radius:20px;
  border: 1px solid white;
}

#gwc-chatOffline {
  background-color: rgb(255, 195, 0);
  color: white
}

#gwc-chatOffline:after {
  position:absolute;
  bottom:0;
  right:0;
  content: '';
  width:15px;
  height:15px;
  background: red;
  border-radius:20px;
  border: 1px solid white;
}

.gnatta-button > img {
  margin-left:6px
}

.gnatta-button {
  background-color: rgb(255, 195, 0);
  align-items: center;
  border-radius: 60px;
  border: 0;
  display: flex;
  height: 44px;
  padding: 16px;
  width: fit-content;
  font-size: 20px;
  font-weight: bold;
  color: white;
  position: fixed;
  bottom: 2%;
  left: 2%;
  z-index: 2;
}

.gnatta-button.hidden {
  display: none;
}


/* css variables */
${cssVariables}
`
